<template>
  <div class="user-container">
    <b-sidebar
      id="sidebar-no-header"
      aria-labelledby="sidebar-no-header-title"
      no-header
      visible
    >
      <b-nav vertical tabs fill>
        <b-nav-item :active="tab === 1" @click="updateView(1)">Dashboard</b-nav-item>
        <b-nav-item :active="tab === 2" @click="updateView(2)">Overview</b-nav-item>
      </b-nav>
    </b-sidebar>
  </div>
</template>

<script>
import defaultImage from "../assets/images/default.png";

export default {
  name: "NavBar",
  props: {
    email: {
      type: String,
    },
  },
  data() {
    return {
      defaultImage,
      tab: 1,
    };
  },
  methods: {
    updateView: function (num) {
        if (num == 1) {
            this.tab = 1
            this.$emit('handleChange', num);
        } else {
            this.tab = 2
            this.$emit('handleChange', num);
        }
      return;
    },
  },
};
</script>

<style scoped>

.avatar-container {
  height: 80px;
  width: 80px;
  margin: 0 auto;
  margin-top: 25px;
}

.discord-avatar {
  max-height: 100%;
  max-width: 100%;
  border-radius: 75px;
}

.discord-tag {
  font-weight: 600;
  margin-top: 20px;
}
</style>